import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';

const config = {
    apiKey: "AIzaSyAcDF3TsBnw6B_jsF-4StsvMyiDMjy2uFE",
    authDomain: "simplemessageboard-a3115.firebaseapp.com",
    databaseURL: "https://simplemessageboard-a3115.firebaseio.com",
    projectId: "simplemessageboard-a3115",
    storageBucket: "simplemessageboard-a3115.appspot.com",
    messagingSenderId: "428797085249"
};
//eslint-disable-next-line
const testConfig = {
    apiKey: "AIzaSyC4_rEvYv0JkEuMxY4WspUMOvlqOMzxULI",
    authDomain: "generationlink-53957.firebaseapp.com",
    databaseURL: "https://generationlink-53957.firebaseio.com",
    projectId: "generationlink-53957",
    storageBucket: "generationlink-53957.appspot.com",
    messagingSenderId: "161347805669"
}

if (!firebase.apps.length) {
  firebase.initializeApp(config);

}
const db = firebase.database();
const auth = firebase.auth();


export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js